import { FC, FormEvent, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Alert, Box, TextField } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { PLATFORM_TOKEN_KEY, errorMessage, platformApi } from './platformApi';
import BrandLogo from '../SignIn/BrandLogo';

const PlatformLogin: FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (localStorage.getItem(PLATFORM_TOKEN_KEY)) {
    return <Navigate to='/platform' replace />;
  }

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await platformApi.post('/auth/login', { email, password });
      localStorage.setItem(PLATFORM_TOKEN_KEY, response.data.token);
      navigate('/platform', { replace: true });
    } catch (err: any) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fafafb', p: 2 }}>
      <Box component='form' onSubmit={onSubmit} noValidate sx={{ width: 380, maxWidth: '100%', bgcolor: '#fff', border: '1px solid #dcdcdc', borderRadius: '8px', p: 3 }}>
        <BrandLogo />
        <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 14, margin: '12px 0 20px' }}>Platform control panel · staff sign-in</h5>
        {error && <Alert severity='error' sx={{ mb: 2 }}>{error}</Alert>}
        <TextField label='Email' type='email' size='small' fullWidth autoFocus autoComplete='username' value={email} onChange={(e) => setEmail(e.target.value)} sx={{ mb: 2 }} />
        <TextField label='Password' type='password' size='small' fullWidth autoComplete='current-password' value={password} onChange={(e) => setPassword(e.target.value)} sx={{ mb: 2 }} />
        <LoadingButton type='submit' variant='contained' fullWidth loading={loading} disabled={!email || !password} sx={{ textTransform: 'none' }}>
          Sign in
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default PlatformLogin;
